module.exports = __webpack_public_path__ + "static/media/towns auditorium.0be9d971.jpeg";